import { Testimonial } from '../types';

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    quote:
      'Luminar took a brief that lived on a single slide and returned a four-day spectacle our board still talks about. The room understood our brand before anyone said a word.',
    author: 'Anaya Rao',
    role: 'Global Head of Brand',
    company: 'Meridian Capital',
  },
  {
    id: 't2',
    quote:
      'They produce like a touring crew and host like a private member’s club. Two thousand guests, zero seams. Quietly the best in the business.',
    author: 'Lukas Wenger',
    role: 'Festival Director',
    company: 'Aria Cultural Trust',
  },
  {
    id: 't3',
    quote:
      'Wedding planners promise the world; Luminar delivers it. Three cities, eleven moving parts, one unforgettable night for our daughter.',
    author: 'Reema & Hari Menon',
    role: 'Private Clients',
    company: 'Mumbai',
  },
];
